import { Drawer, DrawerBody, DrawerContent, DrawerFooter, DrawerHeader, DrawerOverlay } from '@chakra-ui/react';

import { isDefined, isNotDefined } from '@enterprise/core';

import type { SlideOutProps } from './types/slide-out.props';

import { Controls } from './components/controls';
import { Footer } from './components/footer';
import { Header } from './components/header';
import { useSlideOutConfiguration } from './hooks/slide-out-configuration.hook';

import cssClasses from './slide-out.module.css';

export const SlideOut = ({
  children,
  Controls,
  Footer: CustomFooter,
  Header: CustomHeader,
  icon,
  isOpen,
  onClose,
  onOpen,
  showFooter = true,
  title,
  tooltip,
  width,
  ...props
}: SlideOutProps) => {
  const { bodyRef, handleOnClose, open, setClosed } = useSlideOutConfiguration({
    isOpen,
    onClose,
    onOpen,
  });

  return (
    <Drawer
      blockScrollOnMount
      isOpen={open}
      onClose={handleOnClose}
      preserveScrollBarGap
      {...props}>
      <DrawerOverlay />
      <DrawerContent
        className={cssClasses.slideOut}
        maxW={width}
        w={width}>
        <DrawerHeader p={0}>
          {isDefined(CustomHeader) && <CustomHeader onClose={setClosed} />}
          {isNotDefined(CustomHeader) && (
            <Header
              controls={isDefined(Controls) ? <Controls onClose={setClosed} /> : undefined}
              icon={icon}
              onClose={setClosed}
              title={title}
              tooltip={tooltip}
            />
          )}
        </DrawerHeader>
        <DrawerBody
          className="relative"
          ref={bodyRef}>
          {children({ ref: bodyRef })}
        </DrawerBody>
        {showFooter && (
          <DrawerFooter
            className="slide-out-footer"
            p={0}>
            {isDefined(CustomFooter) && <CustomFooter onClose={setClosed} />}
            {isNotDefined(CustomFooter) && (
              <Footer
                controls={isDefined(Controls) ? <Controls onClose={setClosed} /> : undefined}
                onClose={setClosed}
              />
            )}
          </DrawerFooter>
        )}
      </DrawerContent>
    </Drawer>
  );
};

SlideOut.Controls = Controls;
SlideOut.Footer = Footer;
SlideOut.Header = Header;
